// extracted by mini-css-extract-plugin
export default {"rating":"BO-z","numberOfStars":"CO-z","count":"DO-z","barGraphSpacing":"EO-z","barGraph":"FO-z"};